import { render, staticRenderFns } from "./NoteFormBasic.vue?vue&type=template&id=9f677c30"
import script from "./NoteFormBasic.vue?vue&type=script&lang=js"
export * from "./NoteFormBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports